<template>
<div class="row clients">
    <div class="col ">
        <router-view></router-view>
    </div>
</div>
</template>

<script>
export default {
  name: 'Clients',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'Клиенты')
    })
  }
}
</script>
